import { bidders, twinBidders } from '../constants/bidders';

export function bidderByBreakpoint(breakpoint) { return bidders[breakpoint]; }

// Get adunit key as used in bidders constant
export function adUnitKeyByCode(code, bidderObj) {
  const adUnitKeys = Object.keys(bidderObj).filter((unit) => code.indexOf(unit) !== -1);
  return adUnitKeys.length ? adUnitKeys[0] : null;
}

export function adUnitKeyByTwin(key, breakpoint) {
  const twinObj = twinBidders[breakpoint];
  return twinObj ? twinObj[key] : null;
}

// Resolve an ad unit by key and bidder object
export function adUnitByKey(key, bidderObj) {
  return bidderObj[key];
}

// Parse an ad unit
export function parseBidders(adUnit) {
  if (!adUnit) {
    return null;
  }

  const [
    adformMid,
    rubiconZoneId,
    appnexusPlacementId,
    msupplyPlacementId,
    omgzMid,
    iumMid,
    conceptMid,
    criteoZoneId,
    publicisMid,
  ] = adUnit;

  const priceType = 'net';
  // const priceType = 'gross';

  const bids = [];

  if (adformMid) {
    bids.push({
      bidder: 'adform',
      params: {
        mid: adformMid,
        priceType,
      },
    });
  }

  if (rubiconZoneId) {
    bids.push({
      bidder: 'rubicon',
      params: {
        accountId: '13730',
        siteId: '230144',
        zoneId: parseInt(rubiconZoneId, 10),
        priceType,
      },
    });
  }

  if (appnexusPlacementId) {
    bids.push({
      bidder: 'appnexus',
      params: {
        placementId: parseInt(appnexusPlacementId, 10),
        priceType,
      },
    });
  }

  if (msupplyPlacementId) {
    bids.push({
      bidder: 'msupply',
      params: {
        placementId: parseInt(msupplyPlacementId, 10),
        priceType,
      },
    });
  }

  if (omgzMid) {
    bids.push({
      bidder: '638',
      params: {
        mid: parseInt(omgzMid, 10),
        priceType,
      },
    });
  }

  if (iumMid) {
    bids.push({
      bidder: '2606',
      params: {
        mid: parseInt(iumMid, 10),
        priceType,
      },
    });
  }

  if (conceptMid) {
    bids.push({
      bidder: 'Concept',
      params: {
        mid: parseInt(conceptMid, 10),
        priceType: 'gross',
      },
    });
  }

  if (criteoZoneId) {
    bids.push({
      bidder: 'criteo',
      params: {
        networkId: 3359,
        zoneId: criteoZoneId,
        priceType,
      },
    });
  }

  if (publicisMid) {
    bids.push({
      bidder: '2572',
      params: {
        mid: publicisMid,
        priceType,
      },
    });
  }

  return bids;
}

export function parseVideoBidders(adUnit) {
  const bids = [];
  const [adformMid, omgzMid] = adUnit;

  if (adformMid) {
    bids.push({
      bidder: 'adform',
      params: {
        mid: adformMid,
      },
    });
  }

  if (omgzMid) {
    bids.push({
      bidder: '638',
      params: {
        mid: omgzMid,
      },
    });
  }

  return bids;
}
